import { hdrm, template, view } from '@yola/ws-sdk';
import store from 'src/js/store';
import getMaxPaneSize from './get-max-pane-size';
import { PANE_TRIGGER_SIZE } from '../constants/sizes';
import getPageContainerOffset from '../../utils/helpers/get-page-container-offset';
import getTopbarHeight from '../../topbar/accessors/get-height';

const PANE_INDENT = 12;

const getPaneLocationForBlock = ({ element, items, scrollPosition, viewportWidth, isVertical }) => {
  const state = store.getState();

  const pageContainerSelector = template.selectors.getPageContainerSelector(state);
  const pageContainerOffset = getPageContainerOffset(pageContainerSelector);
  const topbarHeight = getTopbarHeight();

  const elementStyles = hdrm.accessors.getElementStyles(element);
  let { elTop } = elementStyles;
  const { elRight, elHeight } = elementStyles;

  // we use bounds of prev element, if it overlaps target one
  // (for ex., header that overlays next block)
  const { referenceMap } = hdrm.instance.driver;
  const prevElementId = referenceMap.getPreviousReferenceId(element);
  const prevElement = view.accessors.getLiveElement(prevElementId);

  if (prevElement) {
    const prevElementStyles = hdrm.accessors.getElementStyles(prevElement);
    const prevElementBottom = prevElementStyles.elTop + prevElementStyles.elHeight;
    if (prevElementBottom > elTop) {
      elTop = prevElementBottom;
    }
  }

  const elTopToPageStart = elTop + scrollPosition - topbarHeight;

  const isElementTopUnderTopbar = elTop - topbarHeight - pageContainerOffset >= 0;

  const { maxPaneWidth } = getMaxPaneSize(items, viewportWidth);

  let positionY;
  let offsetY;

  const direction = 'none';
  const dropdown = 'bottom-left';
  const expand = 'down';

  if (isElementTopUnderTopbar) {
    positionY = 'elTop';
    offsetY = elTopToPageStart + PANE_INDENT;
  } else {
    positionY = 'elTopStickScroll';
    offsetY = scrollPosition + PANE_INDENT;
  }

  if (isVertical) {
    // Place the pane just outside the right edge of the iframe.
    // Derive position from viewportWidth directly to avoid CSS-var timing issues.
    // 5px was added to move pane far from scrollbar
    const offsetX = elRight + PANE_INDENT + 5;

    // Reserve space above the control pane for the AI generate button
    offsetY += PANE_TRIGGER_SIZE;

    // If the pane overflows the viewport bottom, anchor the pane bottom to
    // the block's bottom edge, or to the viewport bottom if the block is also off-screen.
    const paneHeight = items.length * PANE_TRIGGER_SIZE;
    if (
      offsetY + paneHeight + PANE_TRIGGER_SIZE + PANE_INDENT >
      scrollPosition + window.innerHeight
    ) {
      const elBottomInOverlay = elTop + elHeight + scrollPosition;
      const clampedBottom = Math.min(elBottomInOverlay, window.innerHeight + scrollPosition);
      offsetY = clampedBottom - paneHeight - PANE_TRIGGER_SIZE - PANE_INDENT;
      positionY = 'elBottomStickScroll';
    }

    return {
      offsetX,
      offsetY,
      positionX: 'iframeRight',
      positionY,
      direction,
      dropdown,
      expand,
      maxPaneWidth,
    };
  }

  const positionX = 'elRight';
  const offsetX = elRight - maxPaneWidth - PANE_INDENT;

  return {
    offsetX,
    offsetY,
    positionX,
    positionY,
    direction,
    dropdown,
    expand,
    maxPaneWidth,
  };
};

export default getPaneLocationForBlock;
